import { render, staticRenderFns } from "./IconWhatsappLight.vue?vue&type=template&id=0699a577&"
import script from "./IconWhatsappLight.vue?vue&type=script&lang=js&"
export * from "./IconWhatsappLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports